import { lazy } from 'react'
import { BIRMS_DIRECT } from '@services/payment/birmsFlags'
//payments
const PaymentList = lazy(() => import('../../views/payment/list/index'))
const PaymentView = lazy(() => import('../../views/payment/view/index'))
const SyncPaymentRecords = lazy(() => import('../../views/payment/sync-payment-records'))
const BirmsPayments = lazy(() => import('../../views/payment/birms'))

//refunds
const RefundPendingList = lazy(() => import('../../views/refund/list/pending/index'))
const RefundedList = lazy(() => import('../../views/refund/list/refunded/index'))
const AddRefund = lazy(() => import('../../views/refund/add/index'))

const PaymentRoutes = [
  //payment
  {
    path: '/payments',
    element: <PaymentList />
  },
  // BIRMS direct: only when REACT_APP_BIRMS_DIRECT is on (see birmsFlags.js)
  ...(BIRMS_DIRECT ? [{ path: '/payments/birms', element: <BirmsPayments />, meta: { action: 'manage', resource: 'Payment' } }] : []),
  {
    path: '/payments/:applicationNo/view',
    element: <PaymentView />
  },
  {
    path: '/payments/sync-records',
    element: <SyncPaymentRecords />,
    meta: {
      action: 'manage',
      resource: 'Payment'
    }
  },
  //refund
  {
    path: '/refunds/list/pending',
    element: <RefundPendingList />,
    meta: {
      action: 'manage',
      resource: 'Refund'
    }
  },
  {
    path: '/refunds/list/refunded',
    element: <RefundedList />,
    meta: {
      action: 'manage',
      resource: 'Refund'
    }
  },
  {
    path: '/refunds/add',
    element: <AddRefund />,
    meta: {
      action: 'manage',
      resource: 'Refund'
    }
  }
]

export default PaymentRoutes
